import React from 'react';
import { cn } from '../../lib/cn';

export function Card({ className, children, padding = true, as: Comp = 'div' }) {
  return (
    <Comp
      className={cn(
        'rounded-xl border border-slate-200/90 bg-white text-slate-900 shadow-card',
        'dark:border-slate-700/80 dark:bg-slate-900/90 dark:text-slate-100 dark:shadow-card-dark',
        padding && 'p-4 sm:p-6',
        className
      )}
    >
      {children}
    </Comp>
  );
}

export function CardHeader({ className, children }) {
  return <div className={cn('mb-4 border-b border-slate-200 pb-3 dark:border-slate-700', className)}>{children}</div>;
}

export function CardTitle({ className, children }) {
  return <h2 className={cn('text-lg font-semibold text-slate-900 dark:text-slate-100', className)}>{children}</h2>;
}
